import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { SearchSvg } from "../../../svgFiles/SearchSvg";
import Logo from "../../../images/header-logo-captify.svg";
import UserAvatar from "../UserAvatar";
import { Image } from "react-bootstrap";
import { LogoutSvg } from "../../../svgFiles/LogoutSvg";
import { useDebounce } from "../../../helpers/Utils";
import {
  setOrdersTextSearch,
  setPage,
  resetFilters,
} from "../../../app/orderApi/filterSlice";
import { useLocation } from "react-router";
import { useAuth } from "../../../features/auth/AuthContext";
import { getPermissionHomePath } from "../../../helpers/getPermissionHomePath";
import { P } from "../../../utils/permissions";
import "../adminSidebar.css";

const AdminHeader = ({
  intialSearch,
  setIntialSearch,
  withSidebar = false,
  searchOnly = false,
}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [isFocused, setIsFocused] = useState(false);
  const { user, permissions, hasPermission, hasAnyPermission, logout } = useAuth();
  const canSearchOrders = hasAnyPermission(
    P.ORDERS_READ_ALL,
    P.ORDERS_READ_VA,
    P.ORDERS_READ_ASSIGNED,
    P.ORDERS_READ_OWN,
    P.AUDIOLOGIST_ORDER_CREATE
  );

  const debouncedInput = useDebounce(intialSearch, 500);

  useEffect(() => {
    if (!canSearchOrders) return;
    dispatch(setOrdersTextSearch(debouncedInput));
  }, [debouncedInput, dispatch, canSearchOrders]);

  const homePath = getPermissionHomePath(permissions);
  const showOrdersSearch =
    canSearchOrders &&
    (location.pathname === "/orders" || location.pathname === "/distributor");
  // Audiologist uses the same toolbar search as distributor (All + search field).

  if (withSidebar || searchOnly) {
    if (!showOrdersSearch) return null;
    return (
      <div className="d-flex justify-content-center order-filters align-items-center admin-header admin-header--with-sidebar admin-header--search-only bg-white px-4 py-2 sticky-top">
        <div
          className={`search d-flex align-items-center gap-2 w-100 ${isFocused && "activeSearch"}`}
          style={{ maxWidth: 480 }}
        >
          <SearchSvg className={isFocused ? "focusedSvg" : ""} />
          <input
            type="search"
            className="w-100"
            placeholder="Search by order ID, name or email"
            value={intialSearch}
            onChange={(e) => setIntialSearch(e.target.value)}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex gap-3 justify-content-between order-filters align-items-center admin-header sticky-top bg-white px-4 py-2">
      <Image
        role="button"
        height={30}
        src={Logo}
        alt="Captify logo"
        onClick={() => {
          dispatch(setPage(1));
          dispatch(resetFilters());
          if (hasPermission(P.ORDERS_READ_ALL)) {
            dispatch(setOrdersTextSearch(""));
            setIntialSearch?.("");
          }
          window.location.assign(homePath);
        }}
      />

      {showOrdersSearch && (
        <div className={`search d-flex align-items-center gap-2 ${isFocused && 'activeSearch'}`}>
          <SearchSvg className={isFocused ? "focusedSvg" : ""} />
          <input
            type="search"
            className="w-100"
            placeholder="Search by order ID, name or email"
            value={intialSearch}
            onChange={(e) => setIntialSearch(e.target.value)}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
          />

        </div>
      )}
      <div className="logout" onClick={logout}>
        <UserAvatar
          src={user?.picture}
          size={20}
          roundedClassName="rounded-5"
        />
        <span>Logout</span>
        <LogoutSvg />
      </div>

    </div>
  );
};

export default AdminHeader;
